import { dateFormats } from '@rawgraphs/rawgraphs-core'
import { timeFormatLocale, timeParse } from 'd3-time-format'

const SAMPLE_LIMIT = 200

function getParser(dateLocale) {
  return dateLocale ? timeFormatLocale(dateLocale).parse : timeParse
}

function getSampleValues(rows, columnName) {
  return rows
    .map((row) => row?.[columnName])
    .filter((value) => typeof value === 'string')
    .map((value) => value.trim())
    .filter((value) => value.length > 0)
    .slice(0, SAMPLE_LIMIT)
}

const SORTED_DATE_FORMAT_LABELS = Object.keys(dateFormats).sort(
  (a, b) => dateFormats[b].length - dateFormats[a].length
)

export function detectDateFormatForColumn(rows, columnName, dateLocale) {
  const values = getSampleValues(rows, columnName)
  if (values.length < 2) return null

  const parse = getParser(dateLocale)

  for (const label of SORTED_DATE_FORMAT_LABELS) {
    const format = dateFormats[label]
    const parser = parse(format)
    const allMatch = values.every((value) => parser(value) !== null)
    if (allMatch) {
      return label
    }
  }

  return null
}

export function enhanceInferredDateTypes(rows, inferredDataTypes, dateLocale) {
  if (!Array.isArray(rows) || !rows.length || !inferredDataTypes) {
    return inferredDataTypes
  }

  let changed = false
  const nextDataTypes = { ...inferredDataTypes }

  Object.entries(inferredDataTypes).forEach(([columnName, descriptor]) => {
    if (descriptor !== 'string') return

    const detectedFormat = detectDateFormatForColumn(rows, columnName, dateLocale)
    if (!detectedFormat) return

    nextDataTypes[columnName] = {
      type: 'date',
      dateFormat: detectedFormat,
    }
    changed = true
  })

  return changed ? nextDataTypes : inferredDataTypes
}

